import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService extends ApiService {

    index(params: any) {
        return super.get('/sa-invoices', params);
    }

    origins() {
        return super.get('/sa-invoices/origins');
    }

    store(body: any) {
        return super.post(`/sa-invoices`, body);
    }

    show(invoiceId: any) {
        return super.get(`/sa-invoices/${invoiceId}`);
    }

    lastDate() {
        return super.get(`/sa-invoices/last-date`);
    }

    indexLines(params: any) {
        return super.get('/sa-invoice-lines', params);
    }

    edit(invoiceId: any) {
        return super.get(`/sa-invoices/${invoiceId}/edit`);
    }

    update(invoiceId: number, body: any) {
        return super.put(`/sa-invoices/${invoiceId}`, body);
    }

    changeCustomer(invoiceId: number, customerId: string) {
        return super.put(`/sa-invoices/${invoiceId}/customer`, { customer_id: customerId });
    }

    destroy(invoiceId: number) {
        return super.delete(`/sa-invoices/${invoiceId}`);
    }

    previewIdentifier(invoiceId: number) {
        return super.get(`/sa-invoices/${invoiceId}/identifier-preview`);
    }

    previewPdf(invoiceId: number) {
        return super.getFile(`/sa-invoices/${invoiceId}/pdf-preview`);
    }

    regenerateAnnexes(invoiceId: number) {
        return super.post(`/sa-invoices/${invoiceId}/regenerate-annexes`, {});
    }

    resetLinePricing(invoiceId: number, lineId: number) {
        return super.post(`/sa-invoices/${invoiceId}/lines/${lineId}/reset-pricing`, {});
    }

    send(invoiceId: number, body: any) {
        return super.post(`/sa-invoices/${invoiceId}/send`, body);
    }

    print(body: any) {
        return super.post(`/sa-invoices/print`, body);
    }

    createProductSelect(params: any = {}) {
        return super.get(`/sa-invoices/create/products/select`, params);
    }

    finalize(invoiceId: number, body: any) {
        return super.post(`/sa-invoices/${invoiceId}/finalize`, body);
    }

    createCreditNote(invoiceId: number) {
        return super.post(`/sa-invoices/${invoiceId}/credit-note`, {});
    }

    finalizeBatch(ids: number[], invoiceDate: string) {
        return super.post(`/sa-invoices/finalize-batch`, {ids, invoice_date: invoiceDate});
    }

    finalizeBatchStatus(batchId: string) {
        return super.get(`/sa-invoices/finalize-batch/${batchId}`);
    }

    // Lines
    lineStore(invoiceId: number, body: any) {
        return super.post(`/sa-invoices/${invoiceId}/lines`, body);
    }

    lineUpdate(invoiceId: number, lineId: number, body: any) {
        return super.patch(`/sa-invoices/${invoiceId}/lines/${lineId}`, body);
    }

    linesBulkUpdate(invoiceId: number, body: { lines: any[] }) {
        return super.patch(`/sa-invoices/${invoiceId}/lines`, body);
    }

    lineDelete(invoiceId: number, lineId: number) {
        return super.delete(`/sa-invoices/${invoiceId}/lines/${lineId}`);
    }

    // Delivery Notes
    deliveryNoteBillable(invoiceId: number) {
        return super.get(`/sa-invoices/${invoiceId}/delivery-notes/billable`);
    }

    deliveryNoteStore(invoiceId: number, body: any) {
        return super.post(`/sa-invoices/${invoiceId}/delivery-notes`, body);
    }

    deliveryNoteDelete(invoiceId: number, deliveryNoteId: number) {
        return super.delete(`/sa-invoices/${invoiceId}/delivery-notes/${deliveryNoteId}`);
    }

    // Address
    addressList(invoiceId: number) {
        return super.get(`/sa-invoices/${invoiceId}/addresses`);
    }

    addressUpdate(invoiceId: number, body: any) {
        return super.put(`/sa-invoices/${invoiceId}/address`, body);
    }

    createAuto(body: any) {
        return this.post(`/sa-invoices/create/auto`, body);
    }

    // Validation
    validateBatch(ids: number[], auto: boolean = true) {
        return super.post(`/sa-invoices/validate`, {ids, auto});
    }

    validationQueue(params: any = {}) {
        return super.get(`/sa-invoices/validation-queue`, params);
    }

    validationLogs(invoiceId: number) {
        return super.get(`/sa-invoices/${invoiceId}/validation-logs`);
    }

    recheck(invoiceId: number) {
        return super.post(`/sa-invoices/${invoiceId}/recheck`, {});
    }

    manualValidate(invoiceId: number, body: any = {}) {
        return super.post(`/sa-invoices/${invoiceId}/validate-manual`, body);
    }

    revertManualValidate(invoiceId: number) {
        return super.post(`/sa-invoices/${invoiceId}/revert-manual-validate`, {});
    }

    skipSend(invoiceId: number) {
        return super.post(`/sa-invoices/${invoiceId}/do-not-send`, {});
    }

    sendHorus(invoiceId: number) {
        return super.post(`/sa-invoices/${invoiceId}/send-horus`, {});
    }

    stats(params: { from: string; to: string }) {
        return super.get('/sa-invoices/stats', params);
    }

    statsExport(params: { from: string; to: string }) {
        return super.get('/sa-invoices/stats/export', params);
    }
}
